import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { EMPTY_PAYMENT_WALLETS, normalizePaymentWallets } from "@/lib/paymentWallets";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const usePaymentWallets = (token) => {
  const [walletAddresses, setWalletAddresses] = useState(EMPTY_PAYMENT_WALLETS);
  const [walletLoading, setWalletLoading] = useState(true);
  const [walletError, setWalletError] = useState("");

  const fetchWallets = useCallback(async () => {
    if (!token) return;
    try {
      const response = await axios.get(`${API}/billing/wallets`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setWalletAddresses(normalizePaymentWallets(response.data.wallets));
      setWalletError("");
    } catch (error) {
      setWalletError(error.response?.data?.detail || "Unable to load payment wallets.");
    } finally {
      setWalletLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchWallets();
    const handleWalletUpdate = (event) => {
      if (event.detail?.wallets) {
        setWalletAddresses(normalizePaymentWallets(event.detail.wallets));
        setWalletError("");
      } else {
        fetchWallets();
      }
    };
    window.addEventListener("wallets:update", handleWalletUpdate);
    window.addEventListener("billing:poll", fetchWallets);
    return () => {
      window.removeEventListener("wallets:update", handleWalletUpdate);
      window.removeEventListener("billing:poll", fetchWallets);
    };
  }, [fetchWallets]);

  return { walletAddresses, walletLoading, walletError, fetchWallets };
};